import React, { Component } from 'react';

interface TestFillInBlankQuestionContainerProps {
  PlayComponent: React.ComponentType<any>;
  actions: {
    clearData: () => void;
    loadData: (questions: any[]) => any;
    nextQuestion: () => any;
    storeResponseInAttempts?: (response: any) => any;
  };
  conceptsFeedback?: any;
  currentQuestion: any;
  dispatch: any;
  question: any;
  questionID: string;
  questionKey?: string;
}

interface TestFillInBlankQuestionContainerState {
  allResponses: any[];
  gradedResponse?: any;
  key: number;
  responsesForGrading: any[];
}

export class TestFillInBlankQuestionContainer extends Component<TestFillInBlankQuestionContainerProps, TestFillInBlankQuestionContainerState> {
  state = {
    allResponses: [],
    gradedResponse: undefined,
    key: 0,
    responsesForGrading: []
  };

  componentDidMount() {
    this.reset();
  }

  getQuestionsForLesson = () => {
    const { question, questionID, questionKey = 'question' } = this.props;
    const lessonQuestion = { ...question, key: questionID };
    if (!lessonQuestion.attempts) {
      lessonQuestion.attempts = [];
    }
    return [
      {
        [questionKey]: lessonQuestion,
        type: 'FB'
      }
    ];
  };

  reset = () => {
    const { actions, dispatch } = this.props;
    dispatch(actions.clearData());
    this.startActivity();
    this.setState(prevState => ({ key: prevState.key + 1 }));
  };

  setResponse = (response: any) => {
    this.setState({ gradedResponse: response });
  };

  startActivity = () => {
    const { actions, dispatch } = this.props;
    const action = actions.loadData(this.getQuestionsForLesson());
    dispatch(action);
    const next = actions.nextQuestion();
    dispatch(next);
  };

  submitResponse = (response: any) => {
    const { actions, dispatch } = this.props;
    if (actions.storeResponseInAttempts) {
      dispatch(actions.storeResponseInAttempts(response));
    }
  };

  renderGrading = () => {
    const { gradedResponse } = this.state;
    if (gradedResponse) {
      const { response } = gradedResponse;
      const { author, feedback } = response;
      return (
        <div style={{marginTop: '30px'}}>
          <p>Author: {author}</p>
          <p>Feedback: {feedback}</p>
        </div>
      );
    }
    return null;
  };

  render() {
    const { PlayComponent, conceptsFeedback, currentQuestion, dispatch } = this.props;
    const { key } = this.state;

    if (!currentQuestion) {
      return <p>Loading...</p>;
    }

    return (
      <div>
        <div className="test-question-container">
          <PlayComponent
            conceptsFeedback={conceptsFeedback}
            dispatch={dispatch}
            key={key}
            nextQuestion={this.reset}
            prefill={false}
            question={currentQuestion}
            setResponse={this.setResponse}
            submitResponse={this.submitResponse}
          />
        </div>
        {this.renderGrading()}
      </div>
    );
  }
}
